import React     from 'react';
import PropTypes from 'prop-types';

class Tag extends React.Component {
    constructor(props) {
		super(props);
		this.onClick = this.onClickHandler.bind(this);
	}

	onClickHandler(e) {

		e.preventDefault();
		e.stopPropagation();

		if (!this.props.isDisabled && this.props.onToggle) {
			this.props.onToggle(this.props.tag, e);
		}
	}

	render() {
		const selectedClass   = this.props.isSelected ? ' -is-selected' : (this.props.isSelectable ? ' -is-selectable' : '');
		const standaloneClass = this.props.isStandalone ? ' -is-standalone' : '';


		return (
			<div className={'tag-label ' + selectedClass + standaloneClass + (this.props.additionalClassNames ? ' ' + this.props.additionalClassNames : '')}
			      onClick={this.onClick}
			      {...(this.props.isDisabled ? {"aria-disabled": this.props.isDisabled} : {})}
			>
				<span className={'tag-label__content'}>{this.props.tag}</span>
			</div>
		);
	}
}

Tag.propTypes = {
	additionalClassNames: PropTypes.string,
	navigateTo:           PropTypes.func,
	tag:                  PropTypes.string.isRequired,
	onToggle:             PropTypes.func,
	isSelected:           PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	isDisabled:           PropTypes.bool,
	isStandalone:         PropTypes.bool,
	isSelectable:         PropTypes.bool,
	link:                 PropTypes.string,
};

Tag.defaultProps = {
	additionalClassNames: '',
	isSelected:           false,
	isDisabled:           false,
	isSelectable:         true,
	isStandalone:         false,
	link:                 ''
};

export default Tag;
